<template>
  <InstalarPantalla :open="open" tema="cocina" titulo="Pantalla de pedidos" icono="mdi-monitor-dashboard"
    subtitulo="Elige la sucursal de la que verá los pedidos.">
    <div :key="key">
      <ng-select-options v-model="item.bus_subsidiary_id" label="Sucursal" :rules="{ required: true }"
        :items="subsidiaries" :filled="false" :dense="false"></ng-select-options>
    </div>

    <template #acciones="{ invalid }">
      <v-btn block large color="success" elevation="0" @click="install" :loading="loading"
        :disabled="invalid || loading">
        {{ $t("install") }}
      </v-btn>
      <v-btn block text class="mt-2" @click="$store.dispatch('logoutAuth')">
        <v-icon small left>mdi-logout-variant</v-icon> {{ $t("logout") }}
      </v-btn>
    </template>
  </InstalarPantalla>
</template>
<script>
import InstalarPantalla from "@/components/base/InstalarPantalla.vue";
import appUtil from "@/plugins/app-utils.js";

export default {
  name: "Install",
  components: { InstalarPantalla },
  props: ["open"],
  data: () => ({
    dialog: true,
    key: 0,
    subsidiaries: [],
    cashResgisters: [],
    item: { bus_subsidiary_id: null, bill_cash_register_id: null },
    agent: false,
    backup: false,
    loading: false
  }),
  mounted() {
    this.loadSubsidiaries();

  },
  methods: {
    changeLocationHref() {
      appUtil.changeLocationHref()
    },

    install() {
      // Una sola forma para todos: los datos de la sucursal y ella misma en `bus_subsidiary_id`. El formulario
      // la dejaba solo ahí y la instalación automática (una sucursal) solo arriba, y cada una rompía la pantalla.
      const sucursal = this.item.bus_subsidiary_id && this.item.bus_subsidiary_id.id ? this.item.bus_subsidiary_id : this.item;
      this.$store.commit("setStore", { ...sucursal, bus_subsidiary_id: sucursal, bill_cash_register_id: null });
      this.$emit("installed");
    },

    loadSubsidiaries() {
      this.$http.get('api/v1/lists/subsidiary', { '_order': [{ field: "name", direction: "asc" }] })

        .then((response) => {
          if (response.success) {
            this.subsidiaries = response.items;
            if (this.subsidiaries.length == 1) {
              this.item = this.subsidiaries[0];
              this.install()
            }
          }
        });
    },
  },
};
</script>
  